import styled from "styled-components";
import { ClipboardTextLtr } from "@styled-icons/fluentui-system-regular";
import { CheckCircle } from "@styled-icons/boxicons-regular/CheckCircle";
import { Minus } from "@styled-icons/boxicons-regular/Minus";
import { Button } from "components/parts/Button/Button";
import { Typography } from "components/parts/Typography/Typography";
import { newColors } from "constants/newColors";
import { Cross } from "@styled-icons/entypo";
import { colors } from "constants/colors";
import { fontSize } from "constants/fontSize";

export const StyledMonitorPage = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const StyledMonitorManagementContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  padding: 1.5rem 1rem 0 1rem;
  box-sizing: border-box;
`;

export const StyledHeadline = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  box-sizing: border-box;
  margin-bottom: 1rem;
`;

export const StyledSubjectNameContainer = styled.div`
  display: flex;
  column-gap: 0.5rem;
`;

export const StyledMonitorButtonContainerDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const StyledMonitorListWrapper = styled.div`
  min-height: 200px;
  flex-grow: 1;
`;

export const StyledNoDataTypography = styled(Typography)`
  position: relative;
  top: 1rem;
  left: 1rem;
`;

export const StyledClipBoard = styled(ClipboardTextLtr)`
  display: inline;
  height: inherit;
`;

export const StyledClicpBoardPopoverInner = styled.span`
  display: flex;
  flex-direction: column;
  gap: 0.25em;
  padding: 1em;
`;

export const StyledSortButton = styled(Button)`
  padding: 0.2em 0.5em;
  border-radius: 5px;
`;

export const StyledMinus = styled(Minus)`
  color: ${newColors.iconGray};
  width: 24px;
  height: 24px;
`;

export const StyledCheckCircle = styled(CheckCircle)`
  color: ${newColors.green};
  width: 24px;
  height: 24px;
`;

export const StyledCross = styled(Cross)`
  color: ${newColors.red};
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const StyledFixedCheckCircle = styled(CheckCircle)`
  color: ${newColors.blue};
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const StyledConfirmationTextContainer = styled.div`
  font-size: ${fontSize.large};
  margin-bottom: 1rem;
`;

export const StyledVerticalArea = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
`;

export const StyledHorizontalArea = styled.div`
  display: flex;
`;
